import { configureStore } from "@reduxjs/toolkit";
import settingReducer from "./setting/reducers";
import userReducer from "./user/reducers";
export const store = configureStore({
  reducer: {
    setting: settingReducer,
    user: userReducer,
  },
});
